import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/OverviewPage.css";
import PublicHeader from "../components/PublicHeader";
import "../styles/PublicHeader.css";


export default function OverviewPage() {

  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const [activeSection, setActiveSection] = useState(null);
  const [collectionView, setCollectionView] = useState("desktop");

  const navigate = useNavigate();

  const go = (path) => () => {
    setMobileNavOpen(false);
    navigate(path);
  };

const handleSectionClick = (index) => {

const nextSection =
activeSection === index
? null
: index;

setActiveSection(nextSection);

if (nextSection !== null) {
        
setTimeout(() => {

  document
    .getElementById(`section-${index}`)
    ?.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

}, 50); 

}

};


  return (

    <div className={`nav-shell ${mobileNavOpen ? "nav-shell--open" : ""}`}>

      <div
        className={`menu-overlay ${mobileNavOpen ? "open" : ""}`}
        onClick={() => setMobileNavOpen(false)}
      />

      <aside className={`slide-menu ${mobileNavOpen ? "open" : ""}`}>

        <button
          className="menu-close"
          onClick={() => setMobileNavOpen(false)}
        >
          ×
        </button>

        <nav className="menu-nav">

          <button onClick={go("/welcome")}>welcome</button>

          <div className="menu-divider" />

          <button onClick={go("/discover")}>browse collections</button>

          <button onClick={go("/about")}>
            about the platform
          </button>

        </nav>

      </aside>

    <PublicHeader
    mobileNavOpen={mobileNavOpen}
    setMobileNavOpen={setMobileNavOpen}
    showAuth={activeSection === null}
/>
      <main className="overview-page">

        <section className="overview-intro">

          <h1 className="overview-title">
            take the tour.
          </h1>

          <p className="overview-contact">
            questions?
            <br />
            shaq@thecollectorsplatform.com
          </p>

        </section>

        {/* 01 */}

        <div
          className="tour-section"
          id="section-0"
        >

          <button
            className="tour-header"
            onClick={() => handleSectionClick(0)}
          >
            <span className="tour-number">
              01
            </span>

            create your first collection

          </button>

          {activeSection === 0 && (

            <div className="tour-content">

  <div className="tour-frame">

    {collectionView === "desktop" ? (

      <iframe
        src="https://player.vimeo.com/video/1202950331?title=0&byline=0&portrait=0&playsinline=1"
        title="desktop walkthrough"
        allow="fullscreen; picture-in-picture"
        allowFullScreen
      />

      

    ) : (

      <iframe
        src="https://player.vimeo.com/video/1202961026?title=0&byline=0&portrait=0&playsinline=1"
        title="mobile walkthrough"
        allow="fullscreen; picture-in-picture"
        allowFullScreen
      />
      

    )}

  </div>

  <div className="tour-video-tabs">

    <button
      className={
        collectionView === "desktop"
          ? "tour-video-tab active"
          : "tour-video-tab"
      }
      onClick={() => setCollectionView("desktop")}
    >
      desktop
    </button>

    <button
      className={
        collectionView === "mobile"
          ? "tour-video-tab active"
          : "tour-video-tab"
      }
      onClick={() => setCollectionView("mobile")}
    >
      mobile
    </button>

  </div>

  <p>
    start by uploading photos of items in your collection.
    add as many as you like.
  </p>

</div>

          )}

        </div>

        {/* 02 */}

        <div
          className="tour-section"
          id="section-1"
        >

          <button
            className="tour-header"
            onClick={() => handleSectionClick(1)}
          >
            <span className="tour-number">
              02
            </span>

            edit items + add metadata

          </button>

          {activeSection === 1 && (

            <div className="tour-content">

              <div className="tour-frame">

               <iframe
  src="https://player.vimeo.com/video/1202957236?title=0&byline=0&portrait=0&playsinline=1"
  title="edit items"
  allow="fullscreen; picture-in-picture"
  allowFullScreen
/>

              </div>

              <p>
                update descriptions, attach documents,
                add tags and adjust privacy settings.
              </p>

            </div>

          )}

        </div>

        {/* 03 */}

        <div
          className="tour-section"
          id="section-2"
        >

          <button
            className="tour-header"
            onClick={() => handleSectionClick(2)}
          >
            <span className="tour-number">
              03
            </span>

            slice, dice & share your collection

          </button>

          {activeSection === 2 && (

            <div className="tour-content">

              <div className="tour-frame">

                <iframe
                  src="https://player.vimeo.com/video/1129027521?title=0&byline=0&portrait=0&playsinline=1"
                  title="share collection"
                  allow="fullscreen; picture-in-picture"
                  allowFullScreen
                />

              </div>

              <p>
                generate links or PDFs of different versions of your collection.
              </p>

            </div>

          )}

        </div>

        {/* 04 */}
        
        <div
          className="tour-section"
          id="section-3"
        >

          <button
            className="tour-header"
            onClick={() => handleSectionClick(3)}
          >
            <span className="tour-number">
              04
            </span>

            update your profile

          </button>

          {activeSection === 3 && (

            <div className="tour-content">
              <div className="tour-frame">
                <iframe
                  src="https://player.vimeo.com/video/1202939734?title=0&byline=0&portrait=0&playsinline=1"
                  title="share collection"
                   allow="fullscreen; picture-in-picture"
                  allowFullScreen
                />
                
              </div>

              <p>
                update your profile and tell us
                a little about why you collect.
              </p>

            </div>

          )}

        </div>

        {/* 05 */}

        <div
          className="tour-section"
          id="section-4"
        >

          <button
            className="tour-header"
            onClick={() => handleSectionClick(4)}
          >
            <span className="tour-number">
              05
            </span>

            discover collections

          </button>

          {activeSection === 4 && (

            <div className="tour-content">

              <div className="tour-frame">
                <iframe
                  src="https://player.vimeo.com/video/1202932088?title=0&byline=0&portrait=0&playsinline=1"
                  title="share collection"
                  allow="fullscreen; picture-in-picture"
                  allowFullScreen
                />
              </div>

              <p>
                explore publicly shared items
              and discover the stories behind them.
              </p>

            </div>

          )}

        </div>

      </main>

    </div>

  );

}